const useStyles = () => {
	return {
		btn: ' text-violet-50 border-2  flex items-center ring-indigo-300  ring-2  transition ease-in-out delay-150 bg-transparent hover:-translate-y-1 hover:scale-110 hover:bg-blue-800 duration-300 rounded-full px-4 py-3 my-8 ',
	};
};

export default useStyles;
